//deps
import React, { memo, ReactElement } from "react";
import cx from "classnames";

//defs
import { AddMoneyAndDelinkWalletProps } from "@payment-ui/interfaces";

//components
import { Header } from "./components/header";
import { AddMoney } from "./components/add-money";
import { DelinkWallet } from "./components/delink-wallet";

//styles
import styles from "./AddMoneyAndDelinkWallet.scss";

//data-test-ids
import { ADD_MONEY_DELINK_WALLET_DATA_TEST_IDS } from "@swiggy-private/payment-test-ids";
import { isLimitlessWallet } from "@payment-ui/helpers/AddMoneyAndDelinkWallet";

function AddMoneyAndDelinkWallet({
    onAddMoney,
    onDelinkWallet,
    walletDetails,
    isDelinkSuccess,
    showBalance = true,
    onCloseDelinkSuccessBottomSheet,
    onCloseDelinkFailureBottomSheet,
    isDelinkFailure,
    isAddMoneyToWalletEnabled,
    analyticHandlers,
}: AddMoneyAndDelinkWalletProps): ReactElement {
    const headerContainerClass = cx({
        [styles.addMoneyAndDelinkWalletHeader]: !isAddMoneyToWalletEnabled && showBalance,
    });

    const isLimitless = isLimitlessWallet(walletDetails.corporateWalletDetails?.isLimitless);

    return (
        <div
            className={styles.addMoneyAndDelinkWalletContainer}
            data-testid={ADD_MONEY_DELINK_WALLET_DATA_TEST_IDS.CONTAINER}
        >
            <Header
                balance={walletDetails.balance}
                showBalance={showBalance}
                isLimitless={isLimitless}
                iconUrl={walletDetails.iconUrl}
                containerClassName={headerContainerClass}
            />
            {isAddMoneyToWalletEnabled && <AddMoney onAddMoney={onAddMoney} />}
            <DelinkWallet
                onDelinkWallet={onDelinkWallet}
                isDelinkSuccess={isDelinkSuccess}
                isDelinkFailure={isDelinkFailure}
                onCloseSuccessBottomSheet={onCloseDelinkSuccessBottomSheet}
                onCloseFailureBottomSheet={onCloseDelinkFailureBottomSheet}
                walletDetails={walletDetails}
                analyticHandlers={analyticHandlers}
            />
        </div>
    );
}

export default memo(AddMoneyAndDelinkWallet);
